import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-calendar@9.7.9@rc-calendar/es/index.js
// module id = 290
// module chunks = 0